import { render } from "./TandartsVught.vue?vue&type=template&id=6dfc5fa8&scoped=true"
import script from "./TandartsVught.vue?vue&type=script&lang=js"
export * from "./TandartsVught.vue?vue&type=script&lang=js"

import "./TandartsVught.vue?vue&type=style&index=0&id=6dfc5fa8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mraha\\Pictures\\tandzorggestel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dfc5fa8"]])

export default __exports__